import { useEffect } from 'react';

const useScrollEffect = () => {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Trigger scroll event to set initial state
    window.dispatchEvent(new Event('scroll'));
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};

// Function to handle animations when elements come into view
const useIntersectionObserver = () => {
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-section');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all elements with data-animate attribute
    const elements = document.querySelectorAll('[data-animate="fade-in"]');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);
};

// Utility function to set animation delays
const setAnimationDelays = () => {
  const animateElements = document.querySelectorAll('[data-animate="fade-in"]');
  animateElements.forEach((el, index) => {
    (el as HTMLElement).style.animationDelay = `${index * 0.1}s`;
  });
};

// React hook for initializing animations
const useInitAnimations = () => {
  useEffect(() => {
    setAnimationDelays();
  }, []);
};

export { useScrollEffect, useIntersectionObserver, useInitAnimations };